import React from 'react';
import './PictureShowItem.css'


export default function PictureShowItem(props: {
    children?: JSX.Element | Array<JSX.Element>,
}) {
    return (
        <div className="picture-show-item">
            <div className="picture-show-item-bg">
                {props.children}
            </div>
        </div>
    )

}

export function PSIPictureItem(props: {
    children?: string,
    src?: string,
    alt?: string
}) {
    return (
        <PictureShowItem>
            <img src={props.src} className="picture-show-item-img" alt={props.alt}/>
            <div className="picture-show-item-text">{props.children}</div>
        </PictureShowItem>
    )
}